// extracted by mini-css-extract-plugin
export default {"card-item":"card_card-item__v4jZ1"};